import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export function animation() {
  window.addEventListener('DOMContentLoaded', function () {
    gsap.config({ nullTargetWarn: false })

    // フェードインアニメーション
    const fadeInElements = document.querySelectorAll(".js-fade-in");
    fadeInElements.forEach((element) => {
      gsap.fromTo(
        element,
        {
          autoAlpha: 0,
          y: 10,
        },
        {
          autoAlpha: 1,
          y: 0,
          duration: 1.2,
          ease: "power4.out",
          scrollTrigger: {
            trigger: element, // トリガーとなる要素を指定
            start: "top 70%", // スクロール開始位置を指定
            toggleActions: 'play none none reverse',
          },
        }
      );
    });

    // フェードインアニメーション02
    const fadeIn02Elements = document.querySelectorAll(".js-fadeIn");
    fadeIn02Elements.forEach((element) => {
      gsap.fromTo(
        element,
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1,
          duration: 1,
          scrollTrigger: {
            // markers:true,
            trigger: element, // トリガーとなる要素を指定
            start: "top 70%", // スクロール開始位置を指定
            // toggleActions: 'play none none reverse',
          },
        }
      );
    });

    // matchMedia
    const mm = gsap.matchMedia();

    // 761px以上の時 PC
    mm.add('(min-width:761px)', () => {
      const cardWrappers = document.querySelectorAll('.js-card-wrapper');
      cardWrappers.forEach((wrapper) => {
        const cards = wrapper.querySelectorAll('.js-card');
        gsap.fromTo(cards, { autoAlpha: 0, y: 10 },
          {
            y: 0, autoAlpha: 1, stagger: .05, duration: 1, scrollTrigger: {
              trigger: wrapper,
              start: 'top 70%',
            // markers:true,
            }
          }
        );
      });
    });

    // 760px以下の時 sp
    mm.add('(max-width:760px)', function () {
      const cards = document.querySelectorAll('.js-card');
      // card card card cards
      cards.forEach((card) => {
        gsap.fromTo(card, { autoAlpha: 0, y: 10 }, {
          y: 0, autoAlpha: 1, scrollTrigger: {
            trigger: card,
            start: 'top 70%',
            // markers:true,
          }
        });
      });
    });

  })
}
